import { useWorkspace } from '../contexts/WorkspaceContext';
import { getOrpc } from '../lib/orpc';

/** Returns workspace-scoped oRPC utils. Query keys include the workspace slug. */
export function useOrpc(): ReturnType<typeof getOrpc> {
  const { slug } = useWorkspace();
  return getOrpc(slug);
}
